import { ActiveOtp, OtpRequest } from './models/deliveryOtps';
import { OtpsDto, OtpTransporterDto, PastOtpsDto, PastOtpTransporterDto } from './dtos/deliveryOtps';
import {
  dtoToOtps,
  dtoToOtpsTransporter,
  pastOtpDtoToPastOtps,
  pastOtpDtoToPastOtpsTransporter,
  requestToDto
} from './transformers/deliveryOtps';
import { api } from '../utils/apiHelpers';
import { sagwClient } from './clients';

export function createOtp(otpRequest: OtpRequest) {
  return api.post<ActiveOtp>('/v1/b2b/deliveries/otp', JSON.stringify(requestToDto(otpRequest)));
}

export function fetchActiveDeliveryOtps() {
  return api.get<OtpsDto>('/v1/b2b/deliveries/otp').then(dtoToOtps);
}

export function fetchPastDeliveryOtps({ start = 0, limit = 20 } = {}) {
  return api
    .get<PastOtpsDto>('/v1/b2b/deliveries/otpbookings', {
      params: {
        start,
        limit
      }
    })
    .then(pastOtpDtoToPastOtps);
}

export const fetchActiveDeliveryOtpsFromTransporter = () => {
  return sagwClient.get<OtpTransporterDto[]>('/mot/user/deliveries/otp').then(dtoToOtpsTransporter);
};

export function fetchPastDeliveryOtpsFromTransporter({ start = 0, limit = 20 } = {}) {
  return sagwClient
    .get<PastOtpTransporterDto[]>('/mot/user/deliveries/otpbookings', {
      params: {
        start,
        limit
      }
    })
    .then(pastOtpDtoToPastOtpsTransporter);
}

export function createOtpTransporter(otpRequest: OtpRequest) {
  return sagwClient.post<ActiveOtp>('/mot/user/deliveries/otp', JSON.stringify(requestToDto(otpRequest)));
}
